import React, { useState, useCallback } from "react"

import { ChevronLeft, ChevronRight } from "../Hero/HeroUpdate/Chevrons"
import {
  ActiveHr,
  IndexMap,
  StyledHr,
} from "../Hero/HeroUpdate/StyledHeroSlider"

import { decrementSlideIndex, incrementSlideIndex } from "./IndexFunctions"

const IndexMapButtons = ({ slideIndex, componentArray, dark }) => {
  const [idx, setIdx] = useState(slideIndex)

  const increaseIndex = useCallback(() => {
    let newIdx = incrementSlideIndex(idx)
    setIdx(newIdx)
  }, [idx, incrementSlideIndex])

  const decreaseIndex = useCallback(() => {
    let newIdx = decrementSlideIndex(idx)
    setIdx(newIdx)
  }, [idx, decrementSlideIndex])

  return (
    <IndexMap>
      <div className="row">
        <button name="Previous" className="video-prev" onClick={decreaseIndex}>
          <ChevronLeft dark={dark} />
        </button>
        {componentArray?.map((d, i) =>
          i === slideIndex ? (
            <ActiveHr key={i} dark={dark} />
          ) : (
            <StyledHr key={i} dark={dark} />
          )
        )}
        <button name="Next" className="video-next" onClick={increaseIndex}>
          <ChevronRight dark={dark} />
        </button>
      </div>
    </IndexMap>
  )
}

export default IndexMapButtons
